<div class="forgotPasswordPage">
    <mat-card>
        <div fxLayout="row wrap">
            <div fxFlex="100">
                <h2 class="text-muted text-center">Forgot Password</h2>
                <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordFormFormSubmit()">
                    <div fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-form-field appearance="outline" class="mt-2" ngClass.lt-sm="w-100" ngClass.gt-xs="w-70">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput #loginEmailId placeholder="Email" formControlName="email_id" required>
                            <mat-error *ngIf="forgotPasswordForm.controls.email_id.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="forgotPasswordForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                            <mat-error *ngIf="forgotPasswordForm.controls.email_id.hasError('validation')">
                                {{forgotPasswordForm.controls.email_id.errors.message}}                    
                            </mat-error>
                        </mat-form-field>
                        <button mat-raised-button color="primary" class="mat-elevation-z6">
                            Recover
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </mat-card>
</div>